import { localization } from "../localizationManager";

export var farsiStrings = {
  groupButton: "گروه بندی با",
  ungroupButton: "حذف گروه",
  selectButton: "انتخاب",
  hideColumn: "مخفی کردن ستون",
  showColumn: "نمایش ستون",
  makePrivateColumn: "خصوصی کردن ستون",
  makePublicColumn: "عمومی کردن ستون",
  moveToDetail: "انتقال به جزئیات",
  showAsColumn: "نمایش به عنوان ستون",
  filterPlaceholder: "جستجو...",
  removeRows: "حذف سطرها",
  showLabel: "نمایش",
  entriesLabel: "ورودی",
  visualizer_text: "متون در جدول",
  visualizer_wordcloud: "ابر کلمات",
  visualizer_histogram: "هیستوگرام",
  visualizer_number: "متوسط",
  visualizer_choices: "جدول",
  visualizer_selectBase: "نمودار",
  chartType_bar: "میله ای",
  chartType_vbar: "نوار عمودی",
  chartType_stackedbar: "نوار پشته",
  chartType_doughnut: "دونات",
  chartType_pie: "دابره ای(pie)",
  chartType_scatter: "پراکندگی(Scatter)",
  chartType_gauge: "عقربه ای",
  chartType_bullet: "Bullet",
  hideButton: "مخفی",
  makePrivateButton: "خصوصی کردن",
  makePublicButton: "عمومی کردن",
  showButton: "نمایش",
  filter: "فیلتر",
  resetFilter: "بازنشانی فیلترها",
  changeLocale: "تغییر محلی",
  clearButton: "پاک کردن",
  addElement: "انتخاب سوال برای نمایش...",
  defaultOrder: "ترتیب پیشفرض",
  ascOrder: "صعودی",
  descOrder: "نزولی",
  showMinorColumns: "نمایش ستونهای فرعی",
  otherCommentTitle: "سایر موارد و نظرات",
  showPercentages: "نمایش درصد",
  hidePercentages: "درصدهای مخفی",
  pdfDownloadCaption: "پی دی اف",
  xlsxDownloadCaption: "اکسل",
  csvDownloadCaption: "Csv",
  saveDiagramAsPNG: "دانلود طرح به عنوان یک فایل PNG",
  hideEmptyAnswers: "مخفی کردن پاسخهای خالی",
  showEmptyAnswers: "نمایش پاسخهای خالی",
  "topNValueText-1": "همه پاسخ ها",
  topNValueText5: "5 پاسخ برتر",
  topNValueText10: "10 پاسخ برتر",
  topNValueText20: "20 پاسخ برتر",
  hideMissingAnswers: "مخفی کردن پاسخهای گمشده",
  showMissingAnswers: "نمایش پاسخهای گمشده",
  missingAnswersLabel: "پاسخ های گمشده",
  noVisualizerForQuestion: "این نوع سوال هنوز تجسم نشده است",
  noResults: "هنوز نتیجه ای حاصل نشده است",
  showPerValues: "به ازای هر ارزش",
  showPerColumns: "در هر ستون",
  answer: "پاسخ",
  correctAnswer: "پاسخ صحیح: ",
  percent: "درصد",
  responses: "پاسخ"
};

localization.locales["fa"] = farsiStrings;
localization.localeNames["fa"] = "فارسی";

// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// undefined.makePrivateColumn: "Make column private" => "خصوصی کردن ستون"
// undefined.makePublicColumn: "Make column public" => "عمومی کردن ستون"
// undefined.filterPlaceholder: "Search..." => "جستجو..."
// undefined.removeRows: "Remove rows" => "حذف سطرها"
// undefined.showLabel: "Show" => "نمایش"
// undefined.entriesLabel: "entries" => "ورودی"
// undefined.visualizer_histogram: "Histogram" => "هیستوگرام"
// undefined.visualizer_number: "Average" => "متوسط"
// undefined.visualizer_choices: "Table" => "جدول"
// undefined.visualizer_selectBase: "Chart" => "نمودار"
// undefined.chartType_vbar: "Vertical Bar" => "نوار عمودی"
// undefined.chartType_stackedbar: "Stacked Bar" => "نوار پشته"
// undefined.chartType_doughnut: "Doughnut" => "دونات"
// undefined.makePrivateButton: "Make private" => "خصوصی کردن"
// undefined.makePublicButton: "Make public" => "عمومی کردن"
// undefined.showButton: "Show" => "نمایش"
// undefined.filter: "Filter" => "فیلتر"
// undefined.changeLocale: "Change Locale" => "تغییر محلی"
// undefined.defaultOrder: "Default Order" => "ترتیب پیشفرض"
// undefined.ascOrder: "Ascending" => "صعودی"
// undefined.descOrder: "Descending" => "نزولی"
// undefined.showMinorColumns: "Show minor columns" => "نمایش ستونهای فرعی"
// undefined.otherCommentTitle: "Other items and comments" => "سایر موارد و نظرات"
// undefined.showPercentages: "Show percentages" => "نمایش درصد"
// undefined.hidePercentages: "Hide percentages" => "درصدهای مخفی"
// undefined.pdfDownloadCaption: "PDF" => "پی دی اف"
// undefined.xlsxDownloadCaption: "Excel" => "اکسل"
// undefined.csvDownloadCaption: "CSV" => "Csv"
// undefined.saveDiagramAsPNG: "Download plot as a PNG file" => "دانلود طرح به عنوان یک فایل PNG"
// undefined.hideEmptyAnswers: "Hide empty answers" => "مخفی کردن پاسخهای خالی"
// undefined.showEmptyAnswers: "Show empty answers" => "نمایش پاسخهای خالی"
// undefined.topNValueText-1: "All answers" => "همه پاسخ ها"
// undefined.topNValueText5: "Top 5 answers" => "5 پاسخ برتر"
// undefined.topNValueText10: "Top 10 answers" => "10 پاسخ برتر"
// undefined.topNValueText20: "Top 20 answers" => "20 پاسخ برتر"
// undefined.hideMissingAnswers: "Hide missing answers" => "مخفی کردن پاسخهای گمشده"
// undefined.showMissingAnswers: "Show missing answers" => "نمایش پاسخهای گمشده"
// undefined.missingAnswersLabel: "Missing answers" => "پاسخ های گمشده"
// undefined.noVisualizerForQuestion: "This question type is not visualized yet" => "این نوع سوال هنوز تجسم نشده است"
// undefined.noResults: "There are no results yet" => "هنوز نتیجه ای حاصل نشده است"
// undefined.showPerValues: "Per Values" => "به ازای هر ارزش"
// undefined.showPerColumns: "Per Columns" => "در هر ستون"
// undefined.answer: "Answer" => "پاسخ"
// undefined.correctAnswer: "Correct answer: " => "پاسخ صحیح: "
// undefined.percent: "Percent" => "درصد"
// undefined.responses: "Responses" => "پاسخ"
